import { getDate, date, showAlert } from '../../../lib/helpers';
import {
  dataListTaskType,
  dataAllQrType,
  dataListTrackingPengajuanStatus,
  dataDelayServiceHit,
  dataMinRangeDate,
  dataMaxRangeDate,
  dataSourceOnboardingList,
} from '../../../store/params';
import { headers, search } from './attributes';

export default {
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: true,
    rangeDateDialog: false,
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers,
    editedIndex: -1,
    filter: {
      created_at: [],
    },
    search,
    selectedRow: '',
    listTaskType: dataListTaskType,
    listQrType: dataAllQrType,
    listStatus: dataListTrackingPengajuanStatus,
    dateFormatted: '',
    dateMenu: false,
    dateFormattedLastUpdate: '',
    dateMenuLastUpdate: false,
    searchActiveUser: '',
    delayHitService: null,
    sourceOnboardingList: dataSourceOnboardingList,
    filterValue: { created_at: [] },
    filterConfig: [
      { key: 'created_at', type: 'daterange', required: true, props: { label: 'Tanggal Pengajuan', includeToday: true, maxRangeDays: 365 } },
    ]
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.trackingPengajuan.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.trackingPengajuan.flashError;
      },
      set() {
        this.$store.commit('trackingPengajuan/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.trackingPengajuan.errors;
    },
    loading() {
      return this.$store.state.trackingPengajuan.loading;
    },
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    merchants() {
      return this.$store.state.trackingPengajuan.allMerchants;
    },
    totalPage() {
      return this.$store.state.trackingPengajuan.totalPage;
    },
    itemsActiveUser() {
      return this.$store.state.users.allActiveUser;
    },
    totalMerchants() {
      return this.$store.state.trackingPengajuan.totalMerchants;
    },
    dateRangeText() {
      return this.filter.created_at.join(' ~ ');
    },
    minDate() {
      if (this.filter.created_at.length > 0) {
        const tempMinDate = Date.parse(this.filter.created_at[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.filter.created_at.length > 0) {
        const tempMaxDate = Date.parse(this.filter.created_at[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
    /**
     * @returns menentukan apa env filter ch true
     */
    checkFilterCh() {
      return JSON.parse(process.env.VUE_APP_FILTER_CH);
    },
    /**
     * @returns jika env VUE_APP_FILTER_CH true, makan akan sesuai toggle. namun jika tidak, untuk default apakah ch atau bukan dengan env VUE_APP_DB_CH
     */
    checkEnvCh() {
      let filterCh = process.env.VUE_APP_DB_CH;

      if (this.checkFilterCh) {
        const filterOn = process.env.VUE_APP_FILTER_DEFAULT;
        const filterOff = filterOn === 'ch' ? 'sql' : 'ch';
        filterCh = this.switchCh ? filterOn : filterOff;
      }

      return filterCh;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('trackingPengajuan/clearMerchants');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    'search.updated_at': {
      handler() {
        this.dateFormattedLastUpdate = this.formatDate(this.search.updated_at);
      },
    },

    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, dataDelayServiceHit);
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  methods: {
    updateSearch(newSearch) {
      this.search.created_at = newSearch.created_at || [];
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.search.created_at = newSearch.created_at || [];
      this.options.page = 1;
      this.getData(); 
   
    },

    checkRangeDate() {
      if (this.filter.created_at.length === 1) {
        this.filter.created_at.push(this.filter.created_at[0]);
      }
    },
    getDate,

    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.source_onboarding = '';
      this.search.request_by = '';
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.task_type = '';
      this.search.qr_type = '';
      this.search.bcko = '';
      this.search.cmer = '';
      this.search.status = '';
      this.search.reference_number = '';
      this.search.created_at = [];
      this.search.updated_at = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    showData() {
      this.filter.created_at.sort();
      this.search.created_at = this.filter.created_at;
      this.getData();
    },
    getData() {
      if (this.search.created_at.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Tanggal Pengajuan is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('trackingPengajuan/clearMerchants');
      } else {
        this.$store.commit('trackingPengajuan/setFlashErrorMessage', '');
        this.$store.commit('trackingPengajuan/clearErrors');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('trackingPengajuan/fetchMerchants', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage < page) {
                if (this.totalPage === 0) {
                  this.options.page = 1;
                } else {
                  this.options.page = this.totalPage;
                }
              }
            }
            const {errors} = this.$store.state.trackingPengajuan;
            if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
              const messages = Object.values(errors).flat().filter(Boolean);
              if (messages.length > 0) {
                this.$vuetify.goTo(0);
                showAlert(this.$store, messages[0], 'mdi-alert', 'red');
              }
            }
          })
          .catch((err) => {
            this.$vuetify.goTo(0);
            const data = err?.data;
            if (data && typeof data === 'object' && !Array.isArray(data)) {
              const messages = Object.values(data).flat().filter(Boolean);
              if (messages.length > 0) {
                showAlert(this.$store, messages[0], 'mdi-alert', 'red');
                return;
              }
            }
            const msg = err?.message_en || err?.message_id;
            showAlert(this.$store, msg || 'Something went wrong!', 'mdi-alert', 'red');
          });
      }
    },

    getActiveUser() {
      this.$store.dispatch('users/getActiveUser', {
        date,
        userID: this.searchActiveUser,
      });
    },

    viewItem(item) {
      this.$router.push(`/tracking-pengajuan/list/view/${item.id}`);
    },

    closeFlash() {
      this.$store.commit('trackingPengajuan/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    exportExcel() {
      if (this.totalPage < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          search: this.search,
          countData: this.totalMerchants,
          module: 'tracking-pengajuan',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: this.checkEnvCh,
        });
      }
    },
    exportItem() {
      if (this.search.created_at.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'tanggal pengajuan is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('trackingPengajuan/clearMerchants');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('trackingPengajuan/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          view: 'tracking-pengajuan',
          IDMerchant: '',
        });
      }
    },
  },
};